export default __webpack_public_path__ + "static/media/activosCorrientesIcon.43938904.svg";